import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import uuid from '../../../../utils/methods/uuid';
import styles from './PureSelectionList.module.css';

const bindClasses = classNameBind.bind(styles);

const PureSelectionList = ({
  groups,
  onItemSelected,
  noMinWidth,
  selectEvent,
  highlight,
  onHoverElement,
  dataId,
  wrap,
} = {}) => {
  const renderItems = itemsToRender => itemsToRender.map((item) => {
    const onSelected = { [selectEvent]: () => onItemSelected(item) };

    return (
      <li key={item.id || uuid()} className={bindClasses({ active: item.id === highlight })} onMouseEnter={() => { onHoverElement(item.id); }}>
        <div className={bindClasses('item-ctn')}>
          <div className={bindClasses('item-text')}>
            <a role="button" tabIndex="0" {...onSelected}>
              <div>
                <div className={bindClasses('item-text-column')}>
                  {item.checked && <Icon name="checkmark" color="blue" />}
                  <span className={bindClasses({ 'not-selected': !item.checked, selected: item.checked, wrap })}>
                    {item.icon && <Icon name={item.icon} />}
                    {item.name}
                  </span>
                </div>
                {item.caption && (
                <span className={bindClasses('caption')}>
                  {item.caption}
                </span>
                )}
              </div>
            </a>
          </div>
          {item.rightButton && (
            <div className={bindClasses('item-button')}>
              {item.rightButton}
            </div>
          )}
        </div>
      </li>
    );
  });

  return (
    <div className={bindClasses('wrapper', { noMinWidth })} data-ppuc-id={dataId}>
      {groups.map((group, index) => (
        <ul key={group.id || index}>
          {group.name && (
            <li className={bindClasses('group-label')} data-ppuc-id={`${dataId}.groupLabel`}>
              <a>
                <span className={bindClasses('not-selected')}>
                  {group.name}
                </span>
              </a>
            </li>
          )}
          {renderItems(group.items)}
        </ul>
      ))}
    </div>
  );
};

PureSelectionList.defaultProps = {
  noMinWidth: false,
  selectEvent: 'onClick',
  highlight: null,
  onHoverElement: () => {},
  dataId: 'PureSelectionList',
  wrap: false,
};

export default PureSelectionList;
